module.exports = __webpack_public_path__ + "assets/img/detail-img5-d3a438b0.png";